import { ISmartrrOrderFromDb } from "@smartrr/shared/entities/Order";
import { DEFAULT_PAGE_SIZE, PaginationResult } from "@smartrr/shared/utils/paginatedQuery";

import { CustomerSubReducer } from "@customer-app/state/typedCustomerRedux";
import { ISODateString } from "@smartrr/shared/entities/ISODateString";

export interface IOrdersReducerState {
  orders: PaginationResult<ISmartrrOrderFromDb>;
  latestOrder: ISmartrrOrderFromDb | null;
  isLoading: boolean;
}

const initialState: IOrdersReducerState = {
  orders: {
    data: [],
    pageNumber: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    totalCount: 0,
    totalPages: 0,
  },
  latestOrder: null,
  isLoading: true,
};

export const ordersReducer: CustomerSubReducer<IOrdersReducerState> = (state = initialState, action) => {
  switch (action.type) {
    case "LOADING_ORDERS": {
      return {
        ...state,
        isLoading: true,
      };
    }

    case "ERROR_LOADING_ORDERS": {
      return {
        ...state,
        isLoading: false,
      };
    }

    case "LOADED_ORDERS": {
      let newLatestOrder: ISmartrrOrderFromDb | null = state.latestOrder;

      for (const order of action.payload.orders.data) {
        if (newLatestOrder === null) {
          newLatestOrder = order;
        }

        const latestDate = ISODateString.fromString(newLatestOrder.orderProcessedDate).toJSDate();
        const orderDate = ISODateString.fromString(order.orderProcessedDate).toJSDate();

        if (latestDate < orderDate) {
          newLatestOrder = order;
        }
      }

      return {
        ...state,
        isLoading: false,
        orders: action.payload.orders,
        latestOrder: newLatestOrder,
      };
    }

    default: {
      return state;
    }
  }
};
